export const socialIconList = [
  'sh-logo-fb-simple-2',
  'sh-logo-twitter-1',
  'sh-logo-linkedin-5',
  'sh-logo-instagram-1',
  'sh-logo-whatsapp-1',
];

export const socialFieldList = [
  'facebookLink',
  'twitterLink',
  'linkedinLink',
  'instagramLink',
  'websiteLink',
];
